import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

// routes
import { ADMIN_LOGIN, HOME, LOGIN } from './paths';
// hooks
import useAuthContext from '../../hooks/useAuthContext';
import Container from '../../components/Layout/Container';
import AdminLayout from '../../components/Layout/AdminLayout';

const LogoutAndRedirect = ({ logout, to }) => {
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    if (to) {
      navigate(`${to}?logout=true`, { replace: true });
    }
  }, [logout, navigate, to]);

  return null;
};

function Authmiddleware({ component: Component, isAuthProtected, ...rest }) {
  const { user, isAuthenticated, logout } = useAuthContext();
  const location = useLocation();

  if (isAuthenticated && user && user.role === 'client' && rest.type === 'admin') {
    const isLoginPage = location.pathname === ADMIN_LOGIN;
    return <LogoutAndRedirect logout={logout} to={isLoginPage ? null : LOGIN} />;
  }

  if (isAuthProtected && !isAuthenticated) {
    if (rest.type === 'client') {
      return <Navigate to={HOME} />;
    } else {
      return <Navigate to={ADMIN_LOGIN} />;
    }
  }

  if (isAuthProtected && isAuthenticated && user) {
    if (rest.type === user.role) {
      if (user.role === 'client')
        return (
          <Container>
            <Component {...rest} />
          </Container>
        );
      else if (user.role === 'admin') {
        return (
          <AdminLayout>
            <Component {...rest} />
          </AdminLayout>
        );
      }
    } else {
      const path = user.role === 'client' ? ADMIN_LOGIN : HOME;
      return <Navigate to={path} replace />;
    }
  }

  return (
    <Container>
      <Component {...rest} />
    </Container>
  );
}

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
};

export default Authmiddleware;
